<div class="container">

  <div>
    <h3>Sequencing Analysis Viewer Zusammenfassung</h3>
    <div *ngIf="workflowStep.savSummary" class="grid">
      <div></div>
      <div>Read 3</div>
      <div>Read 4</div>

      <ng-container *ngIf="workflowStep.savSummary?.yieldTotalRead1 || workflowStep.savSummary?.yieldTotalRead4">
        <div>Yield Total (GB)</div>
        <div>{{workflowStep.savSummary?.yieldTotalRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.yieldTotalRead4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.projectedYieldRead1 || workflowStep.savSummary?.projectedYieldRead4">
        <div>Projected Yield (GB)</div>
        <div>{{workflowStep.savSummary?.projectedYieldRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.projectedYieldRead4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.alignedRead1 || workflowStep.savSummary?.alignedRead4">
        <div>Aligned (%)</div>
        <div>{{workflowStep.savSummary?.alignedRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.alignedRead4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.errorRateRead1 || workflowStep.savSummary?.errorRateRead4">
        <div>Error Rate (%)</div>
        <div>{{workflowStep.savSummary?.errorRateRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.errorRateRead4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.intensityCycle1Read1 || workflowStep.savSummary?.intensityCycle1Read4">
        <div>Intensity Cycle 1</div>
        <div>{{workflowStep.savSummary?.intensityCycle1Read1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.intensityCycle1Read4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.intensityCycle1PercentRead1 || workflowStep.savSummary?.intensityCycle1PercentRead4">
        <div>% Intensity Cycle 1</div>
        <div>{{workflowStep.savSummary?.intensityCycle1PercentRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.intensityCycle1PercentRead4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.q30PercentRead1 || workflowStep.savSummary?.q30PercentRead4">
        <div>% ≥ Q30</div>
        <div>{{workflowStep.savSummary?.q30PercentRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.q30PercentRead4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.densityRead1 || workflowStep.savSummary?.densityRead4">
        <div>Density (K/mm²)</div>
        <div>{{workflowStep.savSummary?.densityRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.densityRead4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.occupiedRead1 || workflowStep.savSummary?.occupiedRead4">
        <div>% Occupied</div>
        <div>{{workflowStep.savSummary?.occupiedRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.occupiedRead4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.pfPercentRead1 || workflowStep.savSummary?.pfPercentRead4">
        <div>%PF</div>
        <div>{{workflowStep.savSummary?.pfPercentRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.pfPercentRead4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.readsMRead1 || workflowStep.savSummary?.readsMRead4">
        <div>Reads (M)</div>
        <div>{{workflowStep.savSummary?.readsMRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.readsMRead4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.readsPfMRead1 || workflowStep.savSummary?.readsPfMRead4">
        <div>Reads PF (M)</div>
        <div>{{workflowStep.savSummary?.readsPfMRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.readsPfMRead4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.q30PercentRead1 || workflowStep.savSummary?.q30PercentRead4">
        <div>% >= Q30</div>
        <div>{{workflowStep.savSummary?.q30PercentRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.q30PercentRead4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.yieldGbRead1 || workflowStep.savSummary?.yieldGbRead4">
        <div>Yield (GB)</div>
        <div>{{workflowStep.savSummary?.yieldGbRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.yieldGbRead4 | number: '1.3-3'}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.savSummary?.alignedWithErrorRead1 || workflowStep.savSummary?.alignedWithErrorRead4">
        <div>Aligned (%)</div>
        <div>{{workflowStep.savSummary?.alignedWithErrorRead1 | number: '1.3-3'}}</div>
        <div>{{workflowStep.savSummary?.alignedWithErrorRead4 | number: '1.3-3'}}</div>
      </ng-container>
    </div>
    <div *ngIf="!workflowStep.savSummary" class="missing-import">
      <fa-icon [icon]="faFileImport"></fa-icon>
      <div>Warten auf das Empfangen der Datei</div>
    </div>
  </div>

  <div [ngClass]="{'grid-span-run-params': workflowStep.runParameters}">
    <h3>Run Parameters</h3>
    <div *ngIf="workflowStep.runParameters" class="grid-2-columns">
      <ng-container *ngIf="workflowStep.runParameters?.instrumentType">
        <div>Instrument Type</div>
        <div>{{workflowStep.runParameters?.instrumentType}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.instrumentSerialNumber">
        <div>Instrument Serial Nr.</div>
        <div>{{workflowStep.runParameters?.instrumentSerialNumber}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.experimentName">
        <div>Experiment Name</div>
        <div>{{workflowStep.runParameters?.experimentName}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.runID">
        <div>Run ID</div>
        <div>{{workflowStep.runParameters?.runID}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.applicationVersion">
        <div>Application Version</div>
        <div>{{workflowStep.runParameters?.applicationVersion}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.secondaryAnalysisPlatform">
        <div>Secondary Analysis Platform</div>
        <div>{{workflowStep.runParameters?.secondaryAnalysisPlatform}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.secondaryAnalysisVersion">
        <div>Secondary Analysis Version Nr.</div>
        <div>{{workflowStep.runParameters?.secondaryAnalysisVersion}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.dryCartridgeSerialNumber">
        <div>Dry Cartridge Serial Nr.</div>
        <div>{{workflowStep.runParameters?.dryCartridgeSerialNumber}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.dryCartridgeLotNumber">
        <div>Dry Cartridge Lot. Nr.</div>
        <div>{{workflowStep.runParameters?.dryCartridgeLotNumber}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.dryCartridgeVersion">
        <div>Dry Cartridge Version</div>
        <div>{{workflowStep.runParameters?.dryCartridgeVersion}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.wetCartridgeSerialNumber">
        <div>Wet Cartridge Serial Nr.</div>
        <div>{{workflowStep.runParameters?.wetCartridgeSerialNumber}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.wetCartridgeLotNumber">
        <div>Wet Cartridge Lot Nr.</div>
        <div>{{workflowStep.runParameters?.wetCartridgeLotNumber}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.wetCartridgeVersion">
        <div>Wet Cartridge Version</div>
        <div>{{workflowStep.runParameters?.wetCartridgeVersion}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.flowCellSerialNumber">
        <div>FlowCell Serial Nr.</div>
        <div>{{workflowStep.runParameters?.flowCellSerialNumber}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.flowCellVersion">
        <div>FlowCell Version</div>
        <div>{{workflowStep.runParameters?.flowCellVersion}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.runNumber">
        <div>Run Number</div>
        <div>{{workflowStep.runParameters?.runNumber}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.mcsVersion">
        <div>MCS Version</div>
        <div>{{workflowStep.runParameters?.mcsVersion}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.rtaVersion">
        <div>RTA Version</div>
        <div>{{workflowStep.runParameters?.rtaVersion}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.barcode">
        <div>Barcode</div>
        <div>{{workflowStep.runParameters?.barcode}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.pr2BottleBarcode">
        <div>PR2 Bottle Barcode</div>
        <div>{{workflowStep.runParameters?.pr2BottleBarcode}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.reagentKitPartNumberEntered">
        <div>Reagent Kit Part Number Entered</div>
        <div>{{workflowStep.runParameters?.reagentKitPartNumberEntered}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.reagentKitVersion">
        <div>Reagent Kit Version</div>
        <div>{{workflowStep.runParameters?.reagentKitVersion}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.reagentKitBarcode">
        <div>Reagent Kit Barcode</div>
        <div>{{workflowStep.runParameters?.reagentKitBarcode}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.libraryPrepKit">
        <div>Library Prep Kit</div>
        <div>{{workflowStep.runParameters?.libraryPrepKit}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.indexKit">
        <div>Index Kit</div>
        <div>{{workflowStep.runParameters?.indexKit}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.chemistry">
        <div>Chemistry</div>
        <div>{{workflowStep.runParameters?.chemistry}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.username">
        <div>Username</div>
        <div>{{workflowStep.runParameters?.username}}</div>
      </ng-container>

      <ng-container *ngIf="workflowStep.runParameters?.sampleSheetName">
        <div>Sample Sheet Name</div>
        <div>{{workflowStep.runParameters?.sampleSheetName}}</div>
      </ng-container>
    </div>
    <div *ngIf="!workflowStep.runParameters" class="missing-import">
      <fa-icon [icon]="faFileImport"></fa-icon>
      <div>Warten auf das Empfangen der Datei</div>
    </div>
  </div>

  <div
    *ngIf="!readOnly"
    [ngClass]="{'grid-span-file-drop': true, 'margin-top': workflowStep.savSummary, }">
    <app-file-upload [clearFilesOnInput]="true" (onFileSelect)="onUploadNewFile($event)"></app-file-upload>
  </div>

</div>
